export default "__VITE_ASSET__9UVX7nhf__"